import { useEffect, useState } from "react";

/**
 * Returns true when the viewport is narrower than `breakpoint` (default 768px,
 * the Tailwind `md` breakpoint). Used to swap finger-hostile desktop widgets
 * (e.g. react-big-calendar grids) for tap-friendly mobile layouts.
 *
 * SSR-safe: starts from the real width when `window` exists, else `false`,
 * then corrects on mount and on every resize.
 */
export function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth < breakpoint : false
  );

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < breakpoint);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, [breakpoint]);

  return isMobile;
}
